import React, { useContext } from "react";
import { BsSkipBackwardCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import DashboardMain_Bus from "../DashboardMain_Bus/DashboardMain_Bus";
import AppContext from "../../../store/AppContext";

function GlossaryPage_Energy_Bus() {
  const app_ctx = useContext(AppContext);
  return (
    <>
      <DashboardMain_Bus>
        <body style={{ backgroundColor: "white" }}>
          <h1
            style={{
              fontWeight: "bold",
              marginLeft: "2em",
              marginTop: "1em",
              fontSize: "2em",
            }}
            align="center"
          >
            Glossary Page
            <Link
              to="/dashboard_bus/energyanalysis_bus"
              style={{
                color: "rgb(131, 164, 207)",
                marginLeft: "5%",
                fontSize: "0.7em",
              }}
            >
              <BsSkipBackwardCircleFill />
            </Link>
          </h1>

          <table className="table table-hover tableglosary" style={{ width: "50%", height: "20%" }} align="center">
            <thead
              style={{ backgroundColor: "rgb(131, 164, 207)", color: "#fff" }}
            >
              <tr>
                <th scope="col">Sr.No.</th>
                <th scope="col">KPI name</th>
                <th scope="col">Business Logics</th>
                <th scope="col">Backend Formula</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Net Consumption</td>
                <td>Net Kwh Consumption per km of all the discharge cycles of all vehicles</td>
                <td>Total Net Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Energy Consumed</td>
                <td>Actual Kwh consumed per km of all the discharge cycles of all vehicles</td>
                <td>Total Actual Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Energy Regenerated</td>
                <td>Energy Regenerated per km of all the discharge cycles of all vehicles</td>
                <td>Total Regen. Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Traction Sys. Cons. Factor</td>
                <td>Total Motor Kwh consumtion per Km of all the discharge cycles of all vehicles</td>
                <td>Total Motor Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>5</td>
                <td>HVAC Cons. Factor</td>
                <td>Total AC Kwh consumtion per Km of all the discharge cycles of all vehicles</td>
                <td>Total AC Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>6</td>
                <td>AUX-1 Cons. Factor</td>
                <td>Total Aux-1 Kwh consumtion per Km of all the discharge cycles of all vehicles</td>
                <td>Total Aux-1 Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>7</td>
                <td>AUX-2 Cons. Factor</td>
                <td>Total Aux-2 Kwh consumtion per Km of all the discharge cycles of all vehicles</td>
                <td>Total Aux-2 Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>8</td>
                <td>BCS-1 Cons. Factor</td>
                <td>Total BCS-1 Kwh consumtion per Km of all the discharge cycles of all vehicles</td>
                <td>Total BCS-1 Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>9</td>
                <td>BCS-2 Cons. Factor</td>
                <td>Total BCS-2 Kwh consumtion per Km of all the discharge cycles of all vehicles</td>
                <td>Total BCS-2 Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>10</td>
                <td>DC-DC Cons. Factor</td>
                <td>Total DC-DC Kwh consumtion per Km of all the discharge cycles of all vehicles</td>
                <td>Total DC-DC Cons. Kwh/Total Distravelled</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Traction Sys. Cons. Fraction</td>
                <td> Motor Kwh consumtion out of total cons. of all the discharge cycles of all vehicles</td>
                <td>Total Motor Cons. Kwh/Total Actual Cons. Kwh</td>
              </tr>
              <tr>
                <td>12</td>
                <td>HVAC Cons. Fraction</td>
                <td> HVAC Kwh consumtion out of total cons. of all the discharge cycles of all vehicles</td>
                <td>Total AC Cons. Kwh/Total Actual Cons. Kwh</td>
              </tr>
              <tr>
                <td>13</td>
                <td>AUX-1 Cons. Fraction</td>
                <td> AUX-1 Kwh consumtion out of total cons. of all the discharge cycles of all vehicles</td>
                <td>Total Aux-1 Cons. Kwh/Total Actual Cons. Kwh</td>
              </tr>
              <tr>
                <td>14</td>
                <td>AUX-2 Cons. Fraction</td>
                <td>AUX-2 Kwh consumtion out of total cons. of all the discharge cycles of all vehicles</td>
                <td>Total Aux-2 Cons. Kwh/Total Actual Cons. Kwh</td>
              </tr>
              <tr>
                <td>15</td>
                <td>BCS-1 Cons. Fraction</td>
                <td>BCS-1 Kwh consumtion out of total cons. of all the discharge cycles of all vehicles</td>
                <td>Total BCS-1 Cons. Kwh/Total Actual Cons. Kwh</td>
              </tr>
              <tr>
                <td>16</td>
                <td>BCS-2 Cons. Fraction</td>
                <td> BCS-2 Kwh consumtion out of total cons. of all the discharge cycles of all vehicles</td>
                <td>Total BCS-2 Cons. Kwh/Total Actual Cons. Kwh</td>
              </tr>
              <tr>
                <td>17</td>
                <td>DC-DC Cons. Fraction</td>
                <td>DC-DC Kwh consumtion out of total cons. of all the discharge cycles of all vehicles</td>
                <td>Total DC-DC Cons. Kwh/Total Actual Cons. Kwh</td>
              </tr>
            </tbody>
          </table>
        </body>
      </DashboardMain_Bus>
    </>
  );
}

export default GlossaryPage_Energy_Bus;
